import { Box, Skeleton, Stack, Typography } from "@mui/material";
import { format } from "date-fns";

type ReservationCalendarDaySkeletonProps = {
  day: Date;
  delayMs: number;
};

export default function ReservationCalendarDaySkeleton({
  day,
  delayMs,
}: ReservationCalendarDaySkeletonProps) {
  return (
    <Box
      className="calendar-day-box"
      sx={(theme) => ({
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 1,
        padding: 1,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 0.5,
        backgroundColor: theme.palette.background.paper,
        opacity: 1,
      })}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="subtitle2">{format(day, "d")}</Typography>
      </Stack>
      <Box sx={{ flexGrow: 1 }}>
        <Skeleton
          variant="rectangular"
          height="100%"
          sx={{ animationDelay: `${delayMs}ms` }}
        />
      </Box>
    </Box>
  );
}
